module.exports = __webpack_public_path__ + "img/house.9eebcea1.svg";